export type ChangeObjectSidebarControlShownHandler = (shown?: boolean) => void;

export class DatabaseObjectSidebarService {
	private changeObjectSidebarShownHandler: ChangeObjectSidebarControlShownHandler;

	constructor() {
		this.changeObjectSidebarShownHandler = () => {};
	}

	dispose() {
		this.changeObjectSidebarShownHandler = () => {};
	}

	registerChangeObjectSidebarShownHandler(callback: (shown?: boolean) => void) {
		this.changeObjectSidebarShownHandler = callback;
	}

	onChangeObjectSidebarShown(shown: boolean) {
		this.changeObjectSidebarShownHandler(shown);
	}
}
